import { render, staticRenderFns } from "./SaoHeiChatTest.vue?vue&type=template&id=0fb563e3&scoped=true"
import script from "./SaoHeiChatTest.vue?vue&type=script&lang=js"
export * from "./SaoHeiChatTest.vue?vue&type=script&lang=js"
import style0 from "./SaoHeiChatTest.vue?vue&type=style&index=0&id=0fb563e3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb563e3",
  null
  
)

export default component.exports